/**
 * Copyright Highway9 Networks Inc.
 */
import { KPICorrection, KPICorrectionQuery } from "~/types/kpiCorrection";
import APIService from "./APIServices";

const kpiCorrectionsAPI = new APIService<KPICorrection[]>("kpi-corrections");

async function getKPICorrections(query: KPICorrectionQuery): Promise<KPICorrection[]> {
  const data = await kpiCorrectionsAPI.post<KPICorrectionQuery>("query", query);
  const corrections: KPICorrection[] = Array.isArray(data) ? data : [];

  // Sort by window end time descending (newest first)
  corrections.sort(
    (a, b) =>
      new Date(b.endTime || b["@timestamp"]).getTime() - new Date(a.endTime || a["@timestamp"]).getTime(),
  );

  return corrections;
}

export const kpiCorrectionService = {
  getKPICorrections,
};
